import React from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../../components/SEO";

const BestSunglassesUnder1000 = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <SEO 
        title="Best Sunglasses Under ₹1000 in India (2026 Guide)"
        description="Looking for the best sunglasses under ₹1000 in India? Discover stylish, affordable, and UV protected sunglasses from Mark & Luth."
      />

      <h1>Best Sunglasses Under ₹1000 in India (2026 Guide)</h1>

      <p>
        Finding stylish and affordable sunglasses in India can be difficult. 
        Many options either lack quality or don’t provide proper UV protection. 
        At Mark & Luth, we bring you premium-looking sunglasses under ₹1000 without compromising on style or comfort.
      </p>

      <h2>Why Choose Sunglasses Under ₹1000?</h2>
      <p>
        Budget-friendly sunglasses are perfect for everyday use. You don’t need to spend thousands to look stylish. 
        With the right design and quality, affordable sunglasses can offer both protection and fashion.
      </p>

      <h2>Features You Should Look For</h2>
      <ul>
        <li>UV Protection</li>
        <li>Lightweight Frame</li>
        <li>Modern Design</li>
        <li>Durability</li>
      </ul>

      <h2>Top Picks from Mark & Luth</h2>
      <p>
        Our collection includes modern, stylish, and durable sunglasses designed for everyday wear. 
        Whether you prefer classic black frames or trendy designs, we have something for everyone.
      </p>

      <button onClick={() => navigate("/shop")} style={{ padding: "10px 20px", marginTop: "20px" }}>
        Shop Now
      </button>
    </div>
  );
};

export default BestSunglassesUnder1000;